import { createListenerMiddleware } from '@reduxjs/toolkit';
import { baseApi } from '@/shared/api/baseApi';
import { loggedOut, sessionCleared, storeSelected } from '@/shared/lib/redux/actions';
import { clearAllCarts } from '@/entities/cart';

/** Signing out, or switching the current store (§1 «магазины изолированы»), invalidates every RTK
 *  Query cache entry — otherwise a screen could briefly render stale/cross-tenant data. */
export const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  actionCreator: sessionCleared,
  effect: (_action, api) => {
    api.dispatch(baseApi.util.resetApiState());
  },
});

/** Явный выход: корзины клиента на этом устройстве удаляются — следующий вошедший не должен
 *  получить чужие позиции. Именно `loggedOut`, а не `sessionCleared`: тот срабатывает и при
 *  сбое обновления токена, когда корзину того же человека терять незачем. */
listenerMiddleware.startListening({
  actionCreator: loggedOut,
  effect: () => {
    clearAllCarts();
  },
});

listenerMiddleware.startListening({
  actionCreator: storeSelected,
  effect: (_action, api) => {
    api.dispatch(baseApi.util.resetApiState());
  },
});
